import { Const } from '../lib/const.cls'
import * as types from '@/types'
import * as RxFactory from '../../../../store/api/rx-factory'
import * as Enpoints from '../../../../store/api/endpoints'
import * as COMMON from '../../../../store/commomFunction'
import moment from 'moment'
export const actions = {
    [Const.RUN_TRADING_ACCOUNT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_TRADING_ACCOUNT, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (credentials.localParams.from && credentials.localParams.from == 'change-account') {
                    commit(Const.SET_ACCOUNT_SELECTED, credentials.globalParams.is_social)
                    localStorage.setItem('account-type', String(credentials.globalParams.is_social))
                }
                if (parseInt(credentials.globalParams.is_social) == 1) {
                    if (result.res_data.length > 0) {
                        commit(Const.SET_SOCIAL_ACCOUNT, result.res_data)
                    } else {
                        commit(Const.SET_SOCIAL_ACCOUNT, [])
                    }
                } else {
                    if (result.res_data.length > 0) {
                        commit(Const.SET_TRADING_ACCOUNT, result.res_data)
                    } else {
                        commit(Const.SET_TRADING_ACCOUNT, [])
                    }
                }
                /*if (credentials.localParams.page && credentials.localParams.page == 'home') {
                    credentials.localParams.parameter.orderlisting(result.res_data)
                }*/
            } else {
                commit(Const.SET_TRADING_ACCOUNT, [])
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.ADD_FAVORITE_CURRENCY_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_ADD_FAVORITE_CURRENCY_LIST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {

            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.GET_FAVORITE_CURRENCY_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_FAVORITE_CURRENCY_LIST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (result.res_data.length > 0 && result.res_data[0].currencies.length > 0) {
                    credentials.localParams.parameter.fev_list = result.res_data[0].currencies
                    /*if (credentials.localParams.page == 'home') {
                        credentials.localParams.parameter.subscribPairs(result.res_data[0].currencies)
                    }*/
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_DEPOSIT_HISTORY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_DEPOSIT_HISTORY, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                console.log('not completd..')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_WITHDRAWAL_HISTORY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_WITHDRAWAL_HISTORY, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                console.log('not completd..')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.GET_MARGIN_INFO]({ commit, state, getters, dispatch }, credentials) {
        if (('page' in credentials.localParams)) {
            if (Object.keys(getters[Const.GET_MARGIN]).length > 0) {
                if (credentials.globalParams.is_social == 1) {
                    credentials.localParams.parameter.margin_list_social = JSON.parse(JSON.stringify(getters[Const.GET_MARGIN_SOCIAL]))
                }
                credentials.localParams.parameter.margin_list = JSON.parse(JSON.stringify(getters[Const.GET_MARGIN]))
                if (credentials.localParams.page == 'home' || credentials.localParams.page == 'wallet' || credentials.localParams.page == 'portfolio') {
                    setTimeout(() => {
                        credentials.localParams.parameter.changeCurencyUsdValList()
                    }, 1000)
                }
            }
        }
        COMMON._executeApi(Enpoints.EP_GET_MARGIN_INFO, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                const _that = credentials.localParams.parameter
                if (('page' in credentials.localParams)) {
                    credentials.localParams.parameter.margin_list = result.res_data
                    if (credentials.localParams.page == 'exchange') {
                        if (credentials.localParams.page == 'exchange' && _that.$route.params.receiveCurrency) {
                            _that.recive = _that.$route.params.receiveCurrency
                            _that.subscribe()
                            delete _that.$route.params.receiveCurrency
                        }
                    } else if (credentials.localParams.page == 'home' || credentials.localParams.page == 'wallet' || credentials.localParams.page == 'portfolio') {
                        credentials.localParams.parameter.changeCurencyUsdValList()
                    }
                    if (credentials.localParams.page == 'deposit') {
                        credentials.localParams.parameter.transactionLimitCurrency()
                    }
                    if (credentials.globalParams.is_social == 1) {
                        commit(Const.SET_MARGIN_SOCIAL, result.res_data)
                    }
                    commit(Const.SET_MARGIN, result.res_data)
                } else {
                    credentials.localParams.parameter.freeMargin = result.res_data.amount
                    credentials.localParams.parameter.free_Margin = result.res_data.amount
                    try {
                        credentials.localParams.parameter.changeReciveCurr()
                    } catch (error) { }
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_CRYPTO_LIST]({ commit, state, getters, dispatch }, credentials) {
        if (getters[Const.GET_UNIQUE_CRYPTO_LIST].length > 0 && getters[Const.GET_COMBINE_CRYPTO_LIST].length > 0) {
            if (credentials.localParams.page && credentials.localParams.page != 'exchange') {
                credentials.localParams.parameter.subscribe()
            }
            if (credentials.localParams.page && credentials.localParams.page == 'exchange') {
                if (credentials.localParams.parameter.recive == '' && credentials.localParams.parameter.send.currency) {
                    credentials.localParams.parameter.changeReciveCurr()
                }
            }
            return
        }
        COMMON._executeApi(Enpoints.EP_CRYPTO_LIST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_CRYPTO_LIST, result.res_data)
                getCrypto(result.res_data, (err, res) => {
                    if (err) {
                        commit(Const.SET_UNIQUE_CRYPTO_LIST, res.unique.sort())
                        commit(Const.SET_COMBINE_CRYPTO_LIST, res.combine)
                        /*if (credentials.localParams.page && credentials.localParams.page != 'exchange') {
                            credentials.localParams.parameter.subscribe()
                        }*/
                        if (credentials.localParams.page && credentials.localParams.page == 'exchange') {
                            if (credentials.localParams.parameter.recive == '') {
                                credentials.localParams.parameter.changeReciveCurr()
                            }
                        }
                    } else {
                        commit(Const.SET_UNIQUE_CRYPTO_LIST, [])
                        commit(Const.SET_COMBINE_CRYPTO_LIST, [])
                    }
                })
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_ORDER_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_ORDER_LIST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                // commit(Const.SET_ORDER_LIST, result.res_data)
                let open = [], cancle = [], filled = [], sumData = [];
                if (Array.isArray(result.res_data.open_orders)) {
                    result.res_data.open_orders.forEach(val => {
                        let data = val
                        data.Status = 'CREATED'
                        data['sortDate'] = data.Opened
                        if(data.OrderType == 'SL'){
                            let stop = JSON.parse(JSON.stringify(data))
                            let limit = JSON.parse(JSON.stringify(data))
                            stop['OrderType'] = 'S'
                            stop['Price'] = 0
                            limit['OrderType'] = 'L'
                            limit['StopPrice'] = 0
                            open.push(stop)
                            open.push(limit)
                        }else{
                            open.push(data)
                        }
                    })
                    /*open = result.res_data.open_orders.map(val => {
                        let data = val
                        data.Status = 'CREATED'
                        data['sortDate'] = data.Opened
                        return data
                    }).sort((a, b) => {
                        return Date.parse(b.Opened) - Date.parse(a.Opened)
                    })*/
                }
                if (Array.isArray(result.res_data.cancel_orders)) {
                    cancle = result.res_data.cancel_orders.map(val => {
                        let data = val
                        data.Status = 'CANCELED'
                        data['sortDate'] = data.Canceled
                        return data
                    })/*.sort((a, b) => {
                        return Date.parse(b.Canceled) - Date.parse(a.Canceled)
                    })*/
                }
                if (Array.isArray(result.res_data.filled_orders)) {
                    filled = result.res_data.filled_orders.map(val => {
                        let data = val
                        data.Status = 'FILLED'
                        data['sortDate'] = data.Closed
                        return data
                    })/*.sort((a, b) => {
                        return Date.parse(b.Closed) - Date.parse(a.Closed)
                    })*/
                }
                // sumData = open.concat(cancle).concat(filled)
                let allData = open.concat(cancle).concat(filled)
                allData.sort((a, b) => {
                    return Date.parse(b.sortDate) - Date.parse(a.sortDate)
                })
                var openlist = allData.filter(val => val.Status == 'CREATED')
                var canclelist = allData.filter(val => val.Status == 'CANCELED')
                var filledlist = allData.filter(val => val.Status == 'FILLED')

                // sumData = openlist.concat(canclelist).concat(filledlist)
                let stateData = {
                    records: allData,
                    totalRecords: { 'open': openlist.length, 'cancel': canclelist.length, 'filled': filledlist.length }
                }
                if (credentials.globalParams.is_social == 1) {
                    commit(Const.SET_ORDER_LIST_SOCIAL, stateData)
                } else {
                    commit(Const.SET_ORDER_LIST, stateData)
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },

    /* Create social trading account steps */
    [Const.RUN_CREATE_ACCOUNT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_CREATE_ACCOUNT, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                dispatch(Const.RUN_TRADING_ACCOUNT, { globalParams: { is_social: '1' }, localParams: { parameter: this } })
                // dispatch(types.RUN_STATE_LOAD, { 'globalParams': {}, 'localParams': { "parameter": this } })
                commit(types.SET_STATE, Object.assign(getters.GET_USER, { social_type: 1, social_user: 1 }))
                credentials.localParams.parameter.step++
                console.log('not completd..')
            } else {
                credentials.localParams.parameter.error = 'Account could not be created. Please try again later'
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_INTERNAL_TRANSFER_VERIFY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_INTERNAL_TRANSFER_VERIFY, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.internalTransferResponse = result.res_data
                credentials.localParams.parameter.step++
                if (!credentials.globalParams.topup) {
                    commit(types.SET_STATE, Object.assign(getters.GET_USER, { social_type: 1, social_user: 2 }))
                }
                // setTimeout(() => {
                //     dispatch(types.RUN_STATE_LOAD, { 'globalParams': {}, 'localParams': { "parameter": this } })
                // }, 5000)
            } else {
                credentials.localParams.parameter.error = result.res_data
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GENERATE_API_KEY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GENERATE_API_KEY, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                // dispatch(types.RUN_STATE_LOAD, { 'globalParams': {}, 'localParams': { "parameter": this } })
                commit(types.SET_STATE, Object.assign(getters.GET_USER, { social_type: 1, social_user: 3 }))
                credentials.localParams.parameter.apiKeyResponse = result.res_data
                credentials.localParams.parameter.step++
            } else {
                credentials.localParams.parameter.error = result.res_data
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    /* END */

    /** API KEYS */
    [Const.GET_API_KEY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_API_KEYS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.apiKeyResponse = result.res_data
                credentials.localParams.parameter.closeModal('gauthModal')
            } else {
                credentials.localParams.parameter.error = 'Keys could not be fetched. Please try again later'
                credentials.localParams.parameter.closeModal('gauthModal')
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.UPDATE_API_KEY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_UPDATE_API_KEYS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.apiKeyResponse = result.res_data
                credentials.localParams.parameter.closeModal('gauthModal')
            } else {
                credentials.localParams.parameter.error = 'Keys could not be updated. Please try again later.'
                credentials.localParams.parameter.closeModal('gauthModal')
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.DISABLE_API_KEY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_DISABLE_API_KEYS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                dispatch(types.RUN_STATE_LOAD, { 'globalParams': {}, 'localParams': { "parameter": this } })
                credentials.localParams.parameter.apiKeyResponse = []
                credentials.localParams.parameter.closeModal('gauthModal')
            } else {
                credentials.localParams.parameter.error = 'Keys could not be disabled. Please try again later.'
                credentials.localParams.parameter.closeModal('gauthModal')
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    /** END */

    /** PORTFOLIO REPORT */
    [Const.RUN_GET_PORTFOLIO_REPORT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_PORTFOLIO_REPORT, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_PORTFOLIO_REPORT, result.res_data)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },


    /** REVENUE REPORT */
    [Const.RUN_GET_REVENUE_REPORT]({ commit, state, getters, dispatch }, credentials) {
        // function getRandomData() {
        //     let arr = []
        //     for (let i = 15; i >= 1; i--) {
        //         let m = moment()
        //         let obj = {
        //             date: m.subtract(i, 'days').format('DD-MM-YYYY'),
        //             value: (Math.random() * 10000) + (Math.random() * 5000)
        //         }
        //         arr.push(obj)
        //     }
        //     return arr
        // }
        // let data = getRandomData()
        // setTimeout(() => {
        //     commit(Const.SET_REVENUE_REPORT, data)
        // }, 2000);



        COMMON._executeApi(Enpoints.EP_REVENUE_REPORT, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_REVENUE_REPORT, result.res_data.data)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
}


function getCrypto(crypto, callback) {
    try {
        var unique = [];
        let combine = crypto.map((item) => {
            let data = item.isinid
            if (data.includes("-")) {
                unique = unique.concat(data.split("-"));
            } else { unique.push(data) }
            return data
        })
        unique = [...new Set(unique)]
        if (unique.length > 0) {
            callback(true, { 'unique': unique, 'combine': combine })
        }
    } catch (ex) { callback(false, { 'unique': [], 'combine': [] }) }
}
/*
function _executeApi(apiLink, credentials, getToken, commit, callback) {
    try {
        let response_array = []
        if (credentials.localParams.type == 'form') { credentials.globalParams = credentials.globalParams.form }
        if (getToken == '') { getToken = '' }
        credentials.localParams.parameter.pageLoader = true

        RxFactory.post(Enpoints.BASE_URL + apiLink, credentials.globalParams, getToken)
            .map(response => response.data)
            .subscribe(data => {
                    credentials.localParams.parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            response_array.res_data = data.data
                            callback(false, response_array)
                        } else {
                            if (typeof data.msg == 'object') {
                                response_array.res_data = data.msg.msg
                            } else {
                                response_array.res_data = data.msg
                            }
                            callback(true, response_array)
                        }
                    }
                },
                e => { _handleErrorResponse(e, commit) })
    } catch (ex) { _handleErrorResponse(ex, commit) }
}

function _messageDisplayFunction(getParameter, getMessage, msgType) {
    //getParameter.response_msg = getMessage
    //getParameter.msg_type = msgType
    getParameter.$notify({
        group: 'foo',
        type: msgType,
        text: getMessage,
        duration: 10000,
        closeOnClick: true
    });
}

function _cleanUp(commit, msg, status, loaderId) {
    let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
    commit("SET_INFO", msg)
}

function _handleErrorResponse(e, commit) {
    let response = { info: 'NOK', msg: 'Service not available' }
    if (typeof e.response === 'undefined') {
        try {
            const statusCheck = e.toString().toLowerCase()
            if (statusCheck.indexOf('network') > -1) {
                response = { info: 'NOK', msg: 'Network Error' }
            }
        } catch (e) {}
    } else {
        response = e.response.data
    }
    _cleanUp(commit, response, response.status)
    if (typeof e.response !== 'undefined') {
        if (e.response.status == 401) {
            let data = {}
            let options = {}
            options.forward = true
            _handleLogout(data, commit, options)
        }
    }
}

function _handleLogout(data, commit, options) {
    const router = options.router
    let user = {}
    localStorage.clear();
    if ('msg' in data && 'info' in data) {
        _cleanUp(commit, data.msg, data.info)
    }
    if (options.forward === true) {
        window.location.replace("/")
    }
}
*/


// WEBPACK FOOTER //
// ./src/plugins/trading/provider/store-addons/actions.js